import {IRule} from '@mintdata-wsp/common/controllers/spreadsheet/functions/util/text/IRule';

export class NoPaddingRule implements IRule
{
    private readonly _fractionDigitsSeparator = '.';
    private readonly _regexp:RegExp = /^#([,\s]#+)?\.?#*$/;

    public apply(number:number, format:string):string
    {
        number = +number;
        const parts = format.split(this._fractionDigitsSeparator);
        const fractionDigits:number = parts.length == 1 ? 0 : parts[1].length;
        const groupSeparator:string = /,/.test(parts[0]) ? ',' : ' ';
        const groupParts:Array<string> = parts[0].split(groupSeparator);
        const groupSize:number = groupParts.length > 1 ? groupParts[groupParts.length - 1].length : 0;

        const regEx = '\\d(?=(\\d{' + groupSize + '})+' + (fractionDigits > 0 ? '\\D' : '$') + ')';
        const formattedNumber:string = number.toFixed(Math.max(0, ~~fractionDigits));

        return groupSize > 0
            ? formattedNumber.replace(new RegExp(regEx, 'g'), '$&' + (groupSeparator || ','))
            : formattedNumber;
    }

    public matches(format:string):boolean
    {
        return this._regexp.test(format);
    }
}
